import { useEffect, useState } from "react"
import useSWR, { mutate } from "swr"
import { fetchFrontispieces } from "../../models/tieup/novel/fetchFontiesPieces"
import { updateFrontispiece } from "../../models/tieup/novel/updateFrontispiece"
import { fetchFrontispieceContainerId } from "../../models/tieup/novel/fetchFrontispieceContainerId"
import { deleteFrontispiece as deleteFrontispieceFunc } from "../../models/tieup/novel/deleteFrontispiece"
import { Frontispiece } from "../../models/tieup/novel/Frontispiece"

/** 口絵CRUD */
const useFrontispieces = (novelId?: number | null) => {
  const [frontispieces, setFrontispieces] = useState<Frontispiece[]>([])

  const cacheKey = `/v1/mypage/novel/${novelId}/frontispiece`

  const { data } = useSWR(
    novelId ? cacheKey : null,
    async () => {
      return fetchFrontispieces(novelId as number)
    },
    {
      revalidateOnFocus: false,
    },
  )

  /** 画像登録 */
  const uploadFrontispieces = async (file: File) => {
    if (novelId === undefined || novelId === null) {
      return
    }
    /** DBレコード作成 */
    const frontispieceId = await fetchFrontispieceContainerId(novelId)
    await updateFrontispiece(novelId, frontispieceId, file)
    await mutate(cacheKey)
  }

  /** 削除 */
  const deleteFrontispieces = async (frontispieceId: number) => {
    if (novelId === undefined || novelId === null) {
      return
    }
    await deleteFrontispieceFunc(novelId, frontispieceId)
    await mutate(cacheKey)
  }

  useEffect(() => {
    if (data) {
      setFrontispieces(data)
    }
  }, [data])

  return {
    frontispieces,
    uploadFrontispieces,
    deleteFrontispieces,
  }
}

export { useFrontispieces }
